<template>
  <window-container class="product-doc-window">
    <div style="background-color:#b0c8f5;font-weight:bold;padding-left:2px;border-bottom:1px solid #000;margin-bottom:4px;">
      Doc&nbsp;({{ $route.params.id }})
    </div>
    <div class="card">
      <div style="padding:4px;font-weight:bold;background-color:#ddd;">
        Part Number:&nbsp;{{ product.part_no }}&nbsp;&nbsp;&nbsp;
        Description:&nbsp;{{ product.description }}&nbsp;&nbsp;&nbsp;
        Brand:&nbsp;{{ product.brand }}
      </div>
      <div style="margin-top:10px;">
        <strong>Remark:</strong><br/>
        <el-input type="textarea" v-model="remark" :autosize="{ minRows: 4, maxRows: 10}" style="margin-top:10px;"></el-input>
        <br/>
        <el-button type="primary" :disabled="product.doc_remark == remark" @click="saveRemark" style="margin-top:10px;">Save</el-button>
      </div>
      <div style="margin-top:20px;padding:4px;font-weight:bold;background-color:#ddd;">
        Order Record
      </div>
      <el-form ref="form" :model="form" label-width="160px" class="form">
        <el-form-item label="Buyer">
          <!-- el-input v-model="form.buyer" style="width:200px"></el-input -->
          <el-select
            v-model="form.buyer_id"
            filterable
            remote
            allow-create
            default-first-option
            placeholder="搜索或输入Buyer"
            :remote-method="searchBuyer"
            :loading="loading"
            @change="changeBuyer"
            style="width:300px">
            <el-option
              v-for="item in buyerList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Qty">
          <el-input v-model.number="form.qty" style="width:100px;"></el-input>
        </el-form-item>
        <el-form-item label="Cost(USD)">
          <el-input v-model.number="form.cost" style="width:100px;"></el-input>
        </el-form-item>
        <el-form-item label="Buyer Remark">
          <el-input v-model="form.buyer_remark"></el-input>
        </el-form-item>
        <div style="height:4px;border-top:4px solid #999;">&nbsp;</div>
        <el-form-item label="Vendor">
          <!-- el-input v-model="form.vendor" style="width:200px"></el-input -->
          <el-select
            v-model="form.vendor_id"
            filterable
            remote
            allow-create
            default-first-option
            placeholder="搜索或输入Vendor"
            :remote-method="searchVendor"
            :loading="loading"
            @change="changeVendor"
            style="width:300px">
            <el-option
              v-for="item in vendorList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Price(USD)">
          <el-input v-model.number="form.price" style="width:100px;"></el-input>
        </el-form-item>
        <el-form-item label="Vendor Remark">
          <el-input v-model="form.vendor_remark" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="Date">
          <el-input v-model="form.date" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button @click="save">Save</el-button>
          <el-button @click="saveAndExit" v-if="form.id === 0">Save&amp;Exit</el-button>
          <el-button @click="reset" v-if="form.id === 0">Reset</el-button>
          <el-button @click="del" type="danger" v-if="form.id > 0">Delete</el-button>
          <el-button @click="reset" v-if="form.id > 0">Cancel</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="card">
      <div>
        Product No: {{ $route.params.id }} &nbsp;&nbsp;&nbsp;show
        <el-select v-model="pageSize" style="width:120px;" @change="fetchList">
          <el-option label="30 pcs" :value="30"></el-option>
          <el-option label="40 pcs" :value="40"></el-option>
          <el-option label="60 pcs" :value="60"></el-option>
          <el-option label="80 pcs" :value="80"></el-option>
          <el-option label="100 pcs" :value="100"></el-option>
          <el-option label="150 pcs" :value="150"></el-option>
          <el-option label="200 pcs" :value="200"></el-option>
          <el-option label="300 pcs" :value="300"></el-option>
        </el-select>
      </div>
      <div style="margin-top:10px;">
        <table class="cystron-table offer-table">
          <tr style="height:0;border:0">
            <th style="width:25px;"></th>
            <th style="width:70px;"></th>
            <th style="width:120px;"></th>
            <th style="width:50px;"></th>
            <th style="width:70px;"></th>
            <th style="width:110px;"></th>
            <th style="width:40px;"></th>
            <th style="width:100px;"></th>
            <th style="width:70px;"></th>
            <th style="width:100px;"></th>
            <th style="width:40px;"></th>
            <th></th>
          </tr>
          <tr>
            <th colspan="2">
              &nbsp;
            </th>
            <th colspan="5" style="border-right:1px solid #000;">
              Buyer
            </th>
            <th colspan="5">
              Vendor
            </th>
          </tr>
          <tr>
            <th>Edit</th>
            <th>input time</th>
            <th>buyer</th>
            <th>qty</th>
            <th>cost(usd)</th>
            <th>remark</th>
            <th style="border-right:1px solid #000;">sales</th>
            <th>vendor</th>
            <th>price(usd)</th>
            <th>remark</th>
            <th>sales</th>
            <th>date</th>
          </tr>
          <tr v-for="item in list" :key="item.id" :class="item.is_del === '1' ? 'row-red' : (item.is_special === '1' ? 'row-bg-yellow' : '')">
            <td>
              <el-button type="primary" style="padding:0;" @click="edit(item)">edit</el-button>
            </td>
            <td>{{ item.oper_time | shortDate }}</td>
            <td :title="item.buyer">{{ item.buyer }}</td>
            <td>{{ item.qty }}</td>
            <td>{{ item.cost }}</td>
            <td>{{ item.buyer_remark }}</td>
            <td style="border-right:1px solid #000;">{{ item.buyer_sales }}</td>
            <td :title="item.vendor">{{ item.vendor }}</td>
            <td>{{ item.price }}</td>
            <td :title="item.vendor_remark" v-if="item.is_del === '0'">{{ item.vendor_remark }}</td>
            <td v-if="item.is_del === '0'">{{ item.vendor_sales }}</td>
            <td :title="item.date" v-if="item.is_del === '0'">{{ item.date }}</td>
            <td colspan="3" v-else>deleting...</td>
          </tr>
        </table>
        <no-data :loading="false" :list="poList"></no-data>
      </div>
    </div>
  </window-container>
</template>

<script>
import NoData from '@/components/NoData'
export default {
  components: {
    NoData
  },
  data () {
    return {
      product: {},
      remark: '',
      list: [],
      pageSize: 30,
      form: {
        id: 0,
        product_id: this.$route.params.id,
        vendor: '',
        qty: 0,
        cost: 0,
        buyer: '',
        price: 0,
        buyer_remark: '',
        vendor_remark: '',
        date: '',
        buyer_id: 0,
        vendor_id: 0
      },
      buyerList: [],
      vendorList: [],
      loading: false
    }
  },
  mounted () {
    this.fetchProduct()
    this.fetchList()
  },
  methods: {
    fetchProduct () {
      this.$http.get('/dbapi/product_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.product = data.list[0]
          this.remark = this.product.doc_remark
        }
      })
    },
    fetchList () {
      this.$http.get('/dbapi/product_doc_list', {
        params: {
          product_id : this.$route.params.id,
          start: 0,
          limit: this.pageSize
        }
      }).then(data => {
        this.list = data.list
      })
    },
    searchBuyer (query) {
      this.loading = true
      this.$http.get('/dbapi/company_list?start=0&limit=10&query=' + query).then(data => {
        this.loading = false
        this.buyerList = data.list.map(r => {
          return {
            id: r.id,
            name: r.name + '  -' + r.sales_name
          }
        })
      }).catch(e => this.loading = false)
    },
    searchVendor (query) {
      this.loading = true
      this.$http.get('/dbapi/company_list?start=0&limit=10&query=' + query).then(data => {
        this.loading = false
        this.vendorList = data.list.map(r => {
          return {
            id: r.id,
            name: r.name + '  -' + r.sales_name
          }
        })
      }).catch(e => this.loading = false)
    },
    changeBuyer (id) {
      if (!isNaN(id)) {
        let arr = this.buyerList.filter(r => r.id === id)
        if (arr.length > 0) {
          this.form.buyer = arr[0].name
        }
      } else {
        this.form.buyer = id
      }
    },
    changeVendor (id) {
      if (!isNaN(id)) {
        let arr = this.vendorList.filter(r => r.id === id)
        if (arr.length > 0) {
          this.form.vendor = arr[0].name
        }
      } else {
        this.form.vendor = id
      }
    },
    edit (item) {
      this.form.id = item.id
      this.form.vendor = item.vendor
      this.form.qty = item.qty
      this.form.cost = item.cost
      this.form.buyer = item.buyer
      this.form.price = item.price
      this.form.buyer_remark = item.buyer_remark
      this.form.vendor_remark = item.vendor_remark
      this.form.date = item.date
      if (item.buyer_id === 0) {
        this.form.buyer_id = item.buyer
      } else {
        this.buyerList = [{
          id: item.buyer_id,
          name: item.buyer
        }]
        this.form.buyer_id = item.buyer_id
      }
      if (item.vendor_id === 0) {
        this.form.vendor_id = item.vendor
      } else {
        this.vendorList = [{
          id: item.vendor_id,
          name: item.vendor
        }]
        this.form.vendor_id = item.vendor_id
      }
    },
    saveRemark () {
      this.$http.post('/dbapi/product_update_doc_remark', {
        id: this.$route.params.id,
        doc_remark: this.remark
      }).then(result => {
        this.product.doc_remark = this.remark
        this.$message({
          type: 'success',
          message: 'Saved.'
        })
      })
    },
    save () {
      let data = { ...this.form }
      if (data.buyer === data.buyer_id) {
        data.buyer_id = 0
      }
      if (data.vendor === data.vendor_id) {
        data.vendor_id = 0
      }
      let url = data.id > 0 ? '/dbapi/product_doc_update' : '/dbapi/product_doc_insert'
      this.$http.post(url, data).then(result => {
        this.$message({
          type: 'success',
          message: 'Saved.'
        })
        this.fetchList()
        this.reset()
      })
    },
    saveAndExit () {
      this.save()
      this.$close()
    },
    reset () {
      this.form = {
        id: 0,
        product_id: this.$route.params.id,
        vendor: '',
        qty: 0,
        cost: 0,
        buyer: '',
        price: 0,
        buyer_remark: '',
        vendor_remark: '',
        date: ''
      }
    },
    del () {
      this.$confirm('确定要删除吗?', 'Confirm', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/product_doc_del', { id: this.form.id }).then(data => {
          this.$message({
            type: 'success',
            message: 'Deleted.'
          })
          this.fetchList()
          this.reset()
        })
      })
    }
  }
}
</script>

<style lang="scss">
.product-doc-window {
  .form {
    .el-form-item {
      margin-bottom: 0;
      border-bottom: 1px solid #ddd;
    }
    .el-form-item__content {
      border-left: 1px solid #ddd;
      padding: 2px;
    }
  }
  .buttons {
    padding: 4px;
    border-bottom: 1px solid #ddd;
  }
  .footer {
    padding: 4px;
    border-bottom: 1px solid #ddd;
  }
  .offer-table {
    table-layout: fixed;
    td {
      word-break: keep-all;/* 不换行 */
      white-space: nowrap;/* 不换行 */
      overflow: hidden;/* 内容超出宽度时隐藏超出部分的内容 */
      text-overflow: ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
    }
  }
}
</style>

